import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/store';
import { updateClinicalReviewDetails } from '../../../../../../services/CaseManagementService/caseManageSlice';

const statusOptions = [
  'Incomplete',
  'Pending',
  'Complete',
  'Not Required',
  'Does Not Support'
];

const PhysicalTherapyNotesField: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentCase } = useAppSelector(state => state.caseManage);

  const handleChange = (value: string) => {
    dispatch(updateClinicalReviewDetails({
      physicalTherapyNotes: value
    }));
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>Physical Therapy Notes</InputLabel>
      <Select
        value={currentCase?.clinicalReview?.physicalTherapyNotes || 'Incomplete'}
        onChange={(e) => handleChange(e.target.value)}
        label="Physical Therapy Notes"
      >
        {statusOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PhysicalTherapyNotesField;
